import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ArrowRight } from "lucide-react";
import { ReadingProgress } from "./ReadingProgress";
import { glossifyTree } from "./Glossary";
import { trackCtaClick } from "../lib/ctaTracking";
import { useLanguage } from "../context/LanguageContext";
import { useHome } from "../translations/home";

export const DemoCTA = () => {
  const { language } = useLanguage();
  const c = useHome(language).cta;
  return (
    <div className="ink-section py-14 text-center">
      <button
        onClick={() => {
          trackCtaClick("page-cta", language);
          const el = document.querySelector("#demo-form");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }}
        className="rounded-md px-8 py-4 bg-[#0047AB] text-white font-semibold hover:bg-[#0B3F8F] transition-colors inline-flex items-center gap-2"
        data-testid="page-cta-demo"
      >
        {c.label}
        <ArrowRight className="w-5 h-5" />
      </button>
      <p className="text-sm text-[#8A8A8A] mt-3">{c.sub}</p>
    </div>
  );
};

export const PageShell = ({ children, testid }) => {
  const { language } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className="min-h-screen bg-white" data-testid={testid}>
      <ReadingProgress />
      <Navbar isScrolled={isScrolled} />
      <main className="pt-28">{glossifyTree(children, language)}</main>
      <Footer />
    </div>
  );
};

export default PageShell;
